/**
 * Utilidades para filtrar espacios en el sitio público
 */

/**
 * Filtra espacios con tipos privados (solo para sitio público)
 * Los tipos privados NO deben mostrarse en el sitio web, solo en admin
 */
export function filterEspaciosPublicos<T extends { tipo_privado?: boolean }>(
  espacios: T[] | undefined | null
): T[] {
  if (!espacios) return []

  // Filtrar espacios cuyo tipo NO sea privado
  return espacios.filter(espacio => !espacio.tipo_privado)
}

/**
 * Verifica si un espacio tiene tipo privado
 */
export function isEspacioPrivado(espacio: { tipo_privado?: boolean }): boolean {
  return espacio.tipo_privado === true
}
